import {
  Document,
  Paragraph,
  AlignmentType,
  Header,
  UnderlineType,
  WidthType,
  ImageRun,
  VerticalAlign,
  BorderStyle,
  convertInchesToTwip,
  HeightRule,
  VerticalMergeType,
  PageNumber,
} from "docx";
import { AFLType } from "../models";
import { DocxBase } from "../../../../../services/docx.service";
import { Moment } from "moment";
import { DateHelper, StringHelper } from "../../../../../helper";
import flattenDeep from "lodash/flattenDeep";
import { DateFormat } from "../../../../../constants";
import { C, text } from "../../../company-office/request-vehicle/TemplateDocx/Template/common";
import { logoBase64 } from "../../../info-technology-process/repair-tools/base64";

type LayoutType = "header" | "title" | "salutation" | "dateSection" | "content" | "footer";
type Layout = { type: LayoutType; value: any; textBreak?: number };

interface ICreateParams {
  departmentCode: "1" | "2" | "3";
  aflType: AFLType;
  layout: Layout[];
}
const longText = "Lorem Ipsum is simply dummy text of the printing and typesetting industry.";
export class DocumentAFLCreator extends DocxBase {
  create({ departmentCode, aflType, layout }: ICreateParams): Document {
    const children: any[] = [];
    const header: any[] = [];
    for (const item of layout) {
      const { type, value } = item;
      if (type === "header") {
        if (aflType === AFLType.AFLNoSalary) {
          const headerSection = this.headerLogoSection({
            formId: "BM/KHHC/19",
            logo: logoBase64,
            numPublic: 1,
            title: ["ĐƠN XIN NGHỈ KHÔNG", "LƯƠNG"],
            validDate: "01/06/2016",
          });
          header.push(headerSection);
        } else if (aflType === AFLType.AFLSuspendContract) {
          const headerSection = this.headerLogoSection({
            formId: "BM/KHHC/19",
            logo: logoBase64,
            numPublic: 1,
            title: ["ĐƠN XIN TẠM HOÃN HỢP", "ĐỒNG LAO ĐỘNG"],
            validDate: "01/06/2016",
          });
          header.push(headerSection);
        } else if (aflType === AFLType.TerminationContractApplication) {
          const headerSection = this.headerLogoSection({
            formId: "BM/KHHC/19",
            logo: logoBase64,
            numPublic: 1,
            title: ["ĐƠN XIN CHẤM DỨT HỢP", "ĐỒNG LAO ĐỘNG"],
            validDate: "01/06/2016",
          });
          header.push(headerSection);
        } else {
          const headerSection = this.headerSection({
            departmentCode: departmentCode || "1",
            form: value?.form,
            department: value?.department,
            requestId: value?.requestId,
            unitCode: value?.unitCode ?? "",
          });
          header.push(headerSection);
        }
      }
      if (type === "title") {
        children.push(this.titleSection(aflType, value));
      }
      if (type === "salutation") {
        children.push(this.salutationSection(value));
      }
      if (type === "content") {
        children.push(this.contentSection(value));
      }
      if (type === "dateSection") {
        children.push(this.dateSection());
      }
      if (type === "footer") {
        children.push(this.footerSection(value, item.textBreak));
      }
    }

    const document = new Document({
      sections: [
        {
          properties: {
            page: {
              margin: { top: 50, left: 800, right: 800 },
            },
          },
          headers: { default: new Header({ children: [...header] }) },
          children,
        },
      ],
    });
    return document;
  }
  headerSection({ departmentCode, form, department, requestId, unitCode }: any) {
    let textLeftLine1 = "";
    let textLeftLine2 = "";
    let textLeftLine3 = "";
    let textLeftLine4 = "";
    let textRightLine3 = "";

    if (departmentCode === "2") {
      textRightLine3 = "Hà Nội";
      if (form === 1) {
        textLeftLine1 = "CÔNG TY DVMĐ SÂN BAY VIỆT NAM";
        textLeftLine2 = "CHI NHÁNH NỘI BÀI";
        textLeftLine3 = `Số:       /VIAGS-NBA`;
      }
      if (form === 2) {
        textLeftLine1 = "CÔNG TY DVMĐ SÂN BAY VIỆT NAM-CN NỘI BÀI";
        textLeftLine2 = "";
        textLeftLine3 = `Số:...../VIAGS-NBA-(PHÒNG/TT)`;
      }
      if (form === 4) {
        textLeftLine1 = "CÔNG TY DVMĐ SÂN BAY VIỆT NAM-CN NỘI BÀI";
        textLeftLine2 = "PHÒNG/TRUNG TÂM";
        textLeftLine3 = `Số:...../VIAGS-NBA-(PHÒNG/TT)`;
      }
      if (form === 3) {
        textLeftLine1 = "CÔNG TY DVMĐ SÂN BAY VIỆT NAM";
        textLeftLine2 = "CHI NHÁNH NỘI BÀI";
        textLeftLine3 = "Số:       /VIAGS-NBA-(PHÒNG/TT)";
      }
    } else if (departmentCode === "3") {
      textLeftLine1 = "CÔNG TY DVMĐ SÂN BAY VIỆT NAM";
      textLeftLine2 = "CHI NHÁNH ĐÀ NẴNG";
      textLeftLine3 = `Số:       /VIAGS-DAD`;

      textRightLine3 = "Đà Nẵng";
    } else {
      textRightLine3 = "Tp.Hồ Chí Minh";
      if (form === 1) {
        textLeftLine1 = "CÔNG TY DVMĐ SÂN BAY VIỆT NAM";
        textLeftLine2 = "CHI NHÁNH TÂN SƠN NHẤT";
        textLeftLine3 = `${(department || "").toUpperCase()}.`;
        textLeftLine4 = `Số: ${requestId}/VIAGS-${unitCode}`;
      } else if (form === 2) {
        textLeftLine1 = "CÔNG TY DVMĐ SÂN BAY VIỆT NAM";
        textLeftLine2 = `${(department || "").toUpperCase()}`;
        textLeftLine3 = `Số: ${requestId}/VIAGS-${unitCode}`;
      } else {
        textLeftLine1 = "CÔNG TY DVMĐ SÂN BAY VIỆT NAM";
        textLeftLine2 = "CHI NHÁNH TÂN SƠN NHẤT";
        textLeftLine3 = `${(department || "").toUpperCase()}`;
        textLeftLine4 = `Số: ${requestId}/VIAGS-${unitCode}`;
      }
    }

    return this.table({
      rows: [
        this.tableRow({
          children: [
            this.tableCell({
              children: [
                this.paragraph({
                  children: [
                    this.textRun({
                      text: textLeftLine1,
                      size: 26,
                      color: "000000",
                    }),
                    this.textRun({
                      text: textLeftLine2,
                      break: 1,
                      bold: form === 2,
                      size: 26,
                      color: "000000",
                    }),
                    this.textRun({
                      text: textLeftLine3,
                      break: 1,
                      size: 26,
                      bold: form !== 2,
                      color: "000000",
                    }),
                    this.textRun({
                      text: longText,
                      break: 1,
                      size: 8,
                      color: "ffffff",
                      underline: {
                        type: UnderlineType.SINGLE,
                        color: "000000",
                      },
                    }),
                    this.textRun({
                      text: textLeftLine4,
                      break: 1,
                      size: 26,
                      color: "000000",
                    }),
                  ],
                  spacing: {
                    before: 200,
                    after: 200,
                  },
                  alignment: AlignmentType.CENTER,
                }),
              ],
              borders: this.bordersNone(),
              width: this.widthByPercentage("50%"),
            }),
            this.tableCell({
              children: [
                this.paragraph({
                  children: [
                    this.textRun({
                      text: "CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM",
                      bold: true,
                      size: 24,
                      color: "000000",
                    }),
                    this.textRun({
                      text: "Độc lập - Tự do - Hạnh phúc",
                      bold: true,
                      break: 1,
                      size: 26,
                      color: "000000",
                    }),
                    this.textRun({
                      text: longText,
                      break: 1,
                      size: 10,
                      color: "ffffff",
                      underline: {
                        type: UnderlineType.SINGLE,
                        color: "000000",
                      },
                    }),
                    this.textRun({
                      text: `${textRightLine3}, ngày    tháng    năm ${new Date().getFullYear()}`,
                      size: 26,
                      italics: true,
                      bold: true,
                      break: 1,
                    }),
                  ],
                  spacing: {
                    before: 200,
                    after: 200,
                  },
                  alignment: AlignmentType.CENTER,
                }),
              ],
              borders: this.bordersNone(),
              width: this.widthByPercentage("50%"),
            }),
          ],
        }),
      ],
    });
  }

  headerLogoSection(value: { logo: string; formId: string; title: string[]; numPublic: number; validDate: string }) {
    return this.table({
      width: {
        size: "100%",
        type: WidthType.PERCENTAGE,
      },
      rows: [
        this.tableRow({
          children: [
            this.tableCell({
              ...C.col(30, [
                this.paragraph({
                  children: [
                    new ImageRun({
                      data: value.logo,
                      transformation: {
                        width: 150,
                        height: 40,
                      },
                    }),
                  ],
                  alignment: AlignmentType.CENTER,
                }),
              ]),
              verticalAlign: VerticalAlign.CENTER,
              rowSpan: 4,
            }),

            this.tableCell({
              ...C.col(40, [text({ size: 24, text: "Biểu mẫu", italics: true })]),
              borders: { bottom: { style: BorderStyle.NIL } },
              margins: {
                left: convertInchesToTwip(0.07),
                right: convertInchesToTwip(0.07),
              },
            }),
            this.tableCell({
              ...C.col(30, [text({ size: 22, text: `Mã số: ${value.formId}` })]),
              margins: {
                left: convertInchesToTwip(0.07),
                right: convertInchesToTwip(0.07),
              },
            }),
          ],
          height: {
            value: 800,
            rule: HeightRule.AUTO,
          },
        }),
        this.tableRow({
          children: [
            this.tableCell({
              ...C.col(
                44,
                value.title.map((e) => text({ size: 28, text: e, bold: true }, { alignment: AlignmentType.CENTER })),
              ),
              rowSpan: 3,
              borders: { top: { style: BorderStyle.NIL } },
              margins: {
                left: convertInchesToTwip(0.07),
                right: convertInchesToTwip(0.07),
              },
              verticalMerge: VerticalMergeType.RESTART,
              verticalAlign: VerticalAlign.CENTER,
            }),
            this.tableCell({
              ...C.col(30, [text({ size: 24, text: `Lần ban hành: ${value.numPublic + ""}` })]),
              margins: {
                left: convertInchesToTwip(0.07),
                right: convertInchesToTwip(0.07),
              },
            }),
          ],
          height: {
            value: 500,
            rule: HeightRule.AUTO,
          },
        }),
        this.tableRow({
          children: [
            this.tableCell({
              ...C.col(30, [text({ size: 22, text: `Ngày hiệu lực: ${value.validDate}` })]),
              margins: {
                left: convertInchesToTwip(0.07),
                right: convertInchesToTwip(0.07),
              },
            }),
          ],
        }),
        this.tableRow({
          children: [
            this.tableCell({
              ...C.col(33, [
                this.paragraph({
                  children: [
                    this.textRun({
                      children: ["Trang: ", PageNumber.CURRENT, "/", PageNumber.TOTAL_PAGES],
                    }),
                  ],
                }),
              ]),
              margins: {
                left: convertInchesToTwip(0.07),
                right: convertInchesToTwip(0.07),
              },
            }),
          ],
        }),
      ],
    });
  }

  dateSection() {
    return this.paragraph({
      children: [this.div({ text: `……., ngày       tháng        năm`, size: 26, italics: true })],
      alignment: AlignmentType.RIGHT,
    });
  }

  titleSection(aflType: AFLType, { main, sub = [] }: any) {
    let title = "";
    const subTextRun = sub.map((item: string) => this.textRun({ text: item, size: 26, break: 1, italics: true }));

    if (main) {
      title = main;
    } else if (aflType === AFLType.AFLNoSalary) {
      title = "ĐƠN XIN NGHỈ KHÔNG LƯƠNG";
    } else if (aflType === AFLType.AFLSuspendContract) {
      title = "ĐƠN XIN TẠM HOÃN HỢP ĐỒNG LAO ĐỘNG";
    } else if (aflType === AFLType.AccidentLeaveApplication) {
      title = "ĐƠN XIN NGHỈ TAI NẠN RỦI RO /TAI NẠN GIAO THÔNG/ĐIỀU TRỊ BỆNH NGHỀ NGHIỆP/BỆNH DÀI NGÀY";
    } else if (aflType === AFLType.AccidentNotification) {
      title = "THÔNG BÁO TAI NẠN RỦI RO/TAI NẠN GIAO THÔNG";
    } else if (aflType === AFLType.ApplicationForLeave) {
      title = "ĐƠN XIN NGHỈ PHÉP";
    } else if (aflType === AFLType.MaternityLeaveApplication) {
      title = "THÔNG BÁO V/V NGHỈ THAI SẢN";
    } else if (aflType === AFLType.SickLeaveApplication) {
      title = "ĐƠN XIN NGHỈ ỐM/NUÔI CON ỐM";
    } else if (aflType === AFLType.TerminationContractApplication) {
      title = "ĐƠN XIN CHẤM DỨT HỢP ĐỒNG LAO ĐỘNG";
    } else {
      title = "";
    }

    return this.paragraph({
      children: [
        this.textRun({
          text: title,
          bold: true,
          size: 26,
          color: "000000",
          break: 1,
        }),
        ...subTextRun,
      ],
      alignment: AlignmentType.CENTER,
    });
  }
  salutationSection(data: string[]) {
    if (data.length === 1) {
      return this.paragraph({
        children: [this.div({ text: `Kính gửi: ${data[0]}`, size: 26 })],
        alignment: AlignmentType.CENTER,
      });
    }
    const salutations = data.map((item) =>
      this.tableRow({
        children: [
          this.tableCell({
            children: [],
            borders: this.bordersNone(),
          }),
          this.tableCell({
            children: [
              this.paragraph({
                children: [
                  this.span({
                    text: `- ${item}`,
                    size: 26,
                  }),
                ],
              }),
            ],
            borders: this.bordersNone(),
          }),
        ],
      }),
    );
    return this.table({
      rows: [
        this.tableRow({
          children: [
            this.tableCell({
              children: [
                this.paragraph({
                  children: [this.div({ text: "Kính gửi: ", size: 26 })],
                }),
              ],
              borders: this.bordersNone(),
            }),
            this.tableCell({
              children: [],
              borders: this.bordersNone(),
            }),
          ],
        }),
        ...salutations,
      ],
      alignment: AlignmentType.CENTER,
    });
  }
  contentSection(items: { type: string; value: unknown; docxType?: string }[]) {
    const childrenParagraph = items.map((item, index) => {
      const getText: any = {
        eRequestName: this.eRequestName,
        eRequestNameAndId: this.eRequestNameAndId,
        ePosition: this.ePosition,
        eDoBAndSabre: this.eDoBAndSabre,
        ePositionAndTeam: this.ePositionAndTeam,
        eLeavePlace: this.eLeavePlace,
        ePhoneNumber: this.ePhoneNumber,
        eReason: this.eReason,
        eLongReason: this.eLongReason,
        eLongReasonSingleDate: this.eLongReasonSingleDate,
        eVacationPeriod: this.eVacationPeriod,
        eVacationPeriods: this.eVacationPeriods,
        eVacationPeriodNoCount: this.eVacationPeriodNoCount,
        eProxy: this.eProxy,
        eNBAProxy: this.eNBAProxy,
        eWorkPlace: this.eWorkPlace,
        eWorkPlace2: this.eWorkPlace2,
        eWorkPlaceTeam: this.eWorkPlaceTeam,
        eWorkPlaceDepartment: this.eWorkPlaceDepartment,
        eWorkPlaceDeptCenter: this.eWorkPlaceDeptCenter,
        eWorkPlaceDeptCenter2: this.eWorkPlaceDeptCenter2,
        eWorkPlaceTeamAndDept: this.eWorkPlaceTeamAndDept,
        eExpectedReturnDate: this.eExpectedReturnDate,
        eEmployeeId: this.eEmployeeId,
        eStatus: this.eStatus,
        eAccidentTime: this.eAccidentTime,
        eAccidentTime2: this.eAccidentTime2,
        eAccidentReason: this.eAccidentReason,
        eAccidentLocation: this.eAccidentLocation,
        eBusinessTime: this.eBusinessTime,
        eAddress: this.eAddress,
        eThank: this.eThank,
      };

      if (item.docxType === "paragraph") {
        const children = getText[item.type]?.(item.value);

        return children.map((text: string) => this.textRun({ text, size: 26, break: 2 }));
      }

      const text = getText[item.type]?.(item.value) || item.value;
      return this.textRun({ text, size: 26, break: index === 0 ? 1 : 2 });
    });
    return this.paragraph({
      children: flattenDeep(childrenParagraph),
    });
  }
  footerSection(data: any[], textBreak: number = 1) {
    if (data.length === 1) {
      return this.paragraph({
        children: [
          this.textRun({
            text: data[0].value[0],
            size: 26,
            bold: true,
            break: 2,
          }),
          this.textRun({
            text: StringHelper.capitalize(data[0].value[1] || ""),
            size: 26,
            break: 4,
            bold: true,
          }),
        ],
        alignment: AlignmentType.CENTER,
      });
    } else {
      const cellList = data.map((item) => {
        // type = 'signature1' | 'signature2' | 'recipients'
        const { type = "signature1", value = [] } = item;

        let paragraph: Paragraph;

        if (type === "signature1") {
          paragraph = this.paragraph({
            children: [
              this.textRun({
                text: value[0],
                size: 26,
                bold: true,
                break: textBreak,
              }),
              this.textRun({
                text: StringHelper.capitalize(value[1] || ""),
                size: 26,
                break: 4,
                bold: true,
              }),
            ],
            alignment: AlignmentType.CENTER,
          });
        } else if (type === "signature2") {
          paragraph = this.paragraph({
            children: [
              this.textRun({
                text: value[0],
                size: 26,
                bold: true,
                break: textBreak,
              }),
              this.textRun({
                text: StringHelper.capitalize(value[1] || ""),
                size: 26,
                break: 4,
                bold: true,
              }),
            ],
            alignment: AlignmentType.CENTER,
          });
        } else {
          const textRunList = value.map((item: string) =>
            this.textRun({
              text: item,
              size: 26,
              break: 1,
            }),
          );
          paragraph = this.paragraph({
            children: [
              this.textRun({
                text: "Nơi nhận:",
                italics: true,
                size: 26,
                bold: true,
                break: textBreak,
              }),
              ...textRunList,
            ],
            alignment: AlignmentType.START,
          });
        }

        return this.tableCell({
          children: [paragraph],
          borders: this.bordersNone(),
          width: this.widthByPercentage(`${33}%`),
        });
      });
      return this.table({
        rows: [this.tableRow({ children: cellList })],
        width: this.widthByPercentage("100%"),
      });
    }
  }

  eRequestName(name: string) {
    return `Tôi tên là: ${name}`;
  }
  eRequestNameAndId(value: { name: string; id: string }) {
    return `Tôi là: ${value.name}\t\tMã nhân viên: ${value.id}`;
  }
  ePosition(position: string) {
    return `Chức danh: ${position}`;
  }
  ePositionAndTeam(value: { position: string; team: string }) {
    return `Chức danh: ${value.position}\tĐơn vị: ${value.team}`;
  }
  eDoBAndSabre(value: { dob: string; sabre: string }) {
    return `Sinh ngày: ${value.dob}\tCode Sabre (nếu có): ${value.sabre}`;
  }
  eLeavePlace(place: string) {
    return `Nơi nghỉ phép: ${place}`;
  }
  ePhoneNumber(phone: string) {
    return `Điện thoại liên lạc: ${phone}`;
  }
  eReason(reason: string) {
    return `Lý do: ${reason}`;
  }
  eLongReason(value: { reason: string; place: string; range: [Moment, Moment]; title: string; directorTitle: string }) {
    const startDate = DateHelper.formatDateToString(value.range[0]);
    return `Vì lý do: ${value.reason}, kính mong ông ${value.directorTitle}, cho phép tôi được ${value.title} tại ${value.place} kể từ ngày: ${startDate}`;
  }
  eLongReasonSingleDate(value: { reason: string; place: string; date: Moment; title: string; directorTitle: string }) {
    const fromDate = DateHelper.formatDateToString(value.date);
    return `Vì lý do: ${value.reason}, kính mong ông ${value.directorTitle}, cho phép tôi được ${value.title} tại ${value.place} kể từ ngày: ${fromDate}`;
  }
  eVacationPeriod(range: [Moment, Moment]) {
    const startDate = DateHelper.formatDateToString(range[0]);
    const endDate = DateHelper.formatDateToString(range[1]);

    const breakTime = () => {
      if (DateHelper.isSameDate(range)) {
        return DateHelper.getRelativeTime(range);
      }
      return DateHelper.countWeekdays(range);
    };

    if (DateHelper.isSameDate(range)) {
      return `Số lượng ngày phép xin nghỉ: ${breakTime()}, ngày ${startDate}.`;
    }

    return `Số lượng ngày phép xin nghỉ: ${breakTime()} ngày, kể từ ngày ${startDate} đến ngày ${endDate}.`;
  }
  eVacationPeriods(range: Moment[][]) {
    if (range.length > 1) {
      return [
        `Số lượng ngày phép xin nghỉ: ${DateHelper.duration(range).humanize()},`,
        ...range.map(
          (date) =>
            `- Từ ngày ${DateHelper.formatDateToString(date[0], {
              format: DateFormat.DD_MM_YYYY_HH_MM,
            })} đến ngày ${DateHelper.formatDateToString(date[1], {
              format: DateFormat.DD_MM_YYYY_HH_MM,
            })}`,
        ),
      ];
    }
    if (DateHelper.isSameDate(range[0])) {
      return [
        `Số lượng ngày phép xin nghỉ: ${DateHelper.duration(range).humanize()}, ngày ${DateHelper.formatDateToString(
          range[0][0],
        )}.`,
      ];
    }
    return [
      `Số lượng ngày phép xin nghỉ: ${DateHelper.duration(range).humanize()}, từ ngày ${DateHelper.formatDateToString(
        range[0][0],
      )} đến ngày ${DateHelper.formatDateToString(range[0][1])}.`,
    ];
  }
  eVacationPeriodNoCount(range: [Moment, Moment]) {
    const startDate = DateHelper.formatDateToString(range[0]);
    const endDate = DateHelper.formatDateToString(range[1]);
    return `Kể từ ngày ${startDate} đến ngày ${endDate}`;
  }
  eProxy(data: string[] = []) {
    return `Giấy ủy quyền số: ${data[0]}. Ủy quyền cho: ${data[1]}`;
  }
  eNBAProxy(data: string[] = []) {
    return `Giấy ủy quyền số: ${data[0]}/CVUQ-VIAGS-NBA. Ủy quyền cho: ${data[1]}`;
  }
  eWorkPlace(place: string) {
    return `Hiện đang công tác tại: ${place}`;
  }
  eWorkPlace2(place: string) {
    return `Hiện đang công tác tại: ${place}`;
  }
  eWorkPlaceTeam(place: string) {
    return `Hiện làm việc tại Đội: ${place}`;
  }
  eWorkPlaceTeamAndDept(value: { place: string; department: string }) {
    return `Hiện làm việc tại Đội: ${value.place} thuộc Phòng/Trung tâm: ${value.department}`;
  }
  eWorkPlaceDeptCenter(place: string) {
    return `Hiện làm việc tại phòng/trung tâm: ${place}`;
  }
  eWorkPlaceDeptCenter2(place: string) {
    return `Hiện đang công tác tại phòng/trung tâm: ${place}`;
  }
  eWorkPlaceDepartment(place: string) {
    return `Phòng: ${place[0]} thuộc ${place[1]}`;
  }
  eExpectedReturnDate(date: Moment) {
    return `Thời gian (dự kiến) trở lại làm việc: ${DateHelper.formatDateToString(date)}`;
  }
  eEmployeeId(id: string) {
    return `Mã nhân viên: ${id}`;
  }
  eStatus(status: string) {
    return `Tình trạng: ${status}`;
  }
  eAccidentTime(data: Moment) {
    const date = DateHelper.formatDateToString(data);
    return `Thời gian tai nạn: ${DateHelper.formatDateToString(date)} `;
  }
  eAccidentTime2(data: string) {
    return `Thời gian tai nạn: ${data} `;
  }
  eAccidentReason(reason: string) {
    return `Lý do tai nạn: ${reason || ""}`;
  }
  eAccidentLocation(location: string) {
    return `Địa điểm tai nạn: ${location}`;
  }
  eBusinessTime(time: string) {
    return `Thời gian công tác tại cơ quan, chi nhánh: ${time}`;
  }
  eAddress(place: string) {
    return `Địa chỉ thường trú: ${place}`;
  }
  eThank() {
    return "Xin trân trọng cảm ơn.";
  }
}
